import React, { useState, useEffect } from 'react';
import langData from '../locales/langData.json';
import frMainthree from '../assets/images/pro-child1.webp';
import frMaintwo from '../assets/images/pro-child2.webp';
import frMainone from '../assets/images/pro-child3.webp';
import arrow from '../assets/images/right-arrow.webp';
import gif from '../assets/gif/bgs.gif';
import { FaArrowRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import ClientLogoMarquee from '../components/ClientLogoMarquee';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import SEO from '../components/SEO';
import '../assets/css/Product.css';

const Product = ({ language }) => {
  const products = langData[language].products;
  const cardoverlay = products.cardoverlay;
  const clientlogos = langData[language].clientlogo;

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <SEO
        title="CaptainX Suite | Smart Sports Tech for Academies & Teams"
        titleAr="كابتن اكس | تقنيات رياضية ذكية للأكاديميات والفرق"
        description="A complete AI-powered solution for academies, federations, and clubs to transform operations, strategy, and athlete performance."
        descriptionAr="حل كامل مدعوم بالذكاء الاصطناعي للأكاديميات والاتحادات والأندية لتحويل العمليات والاستراتيجيات وأداء الرياضيين."
        path="/products"
        language={language}
      />

      {/* Hero Section */}
      <section className='product-hero-section'>
        <div className="first-product-part pt-4">
          <div className="container">
            <div className="row py-4">
              <div className="col-md-6 pro-flx">
                <h2
                  className='sec-title mt-5 block-view'
                  dangerouslySetInnerHTML={{ __html: products.heroTitle }}
                />
                <p
                  className='block-view sec-p'
                  dangerouslySetInnerHTML={{ __html: products.heroDesc }}
                />
                <div className="mob-btn">
                  <Link to='/#expolare' className='under-line'>
                    <button
                      className={`explore-btn cta-btn gap-3 ${
                        language === 'ar' ? 'ar-padding' : 'en-padding'
                      }`}
                    >
                      {products.exploreBtn}
                      <LazyLoadImage src={arrow} alt="arrow" className="rt-btn" />
                    </button>
                  </Link>
                </div>
              </div>

              <div className="col-md-1"></div>

              <div className="col-md-5">
                <div className="card-proud-images">
                  <div className="card-prod-img d-none d-md-flex"></div>
                  <div className="card-proud-second">
                    <LazyLoadImage src={frMaintwo} alt="product-main" className='pro-1' />
                    <LazyLoadImage src={frMainone} alt="product-main" className='pro-2' />
                    <LazyLoadImage src={frMainthree} alt="product-main" className='pro-3' />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Client Logo Marquee */}
        <center className='mb-3'>
          <h5 className="second-cen-text pt-3">{products.morequee}</h5>
          <ClientLogoMarquee logos={clientlogos} language={language} />
        </center>
      </section>
 <section
      className={`overaly-sec ${language === "ar" ? "rtl" : "ltr"}`}
      dir={language === "ar" ? "rtl" : "ltr"}
    >
      <center className="pos-fix">
        <h6 className="sec-top-titl block-view">{products.solutionTop}</h6>
        <h2
          className="sec-title block-view"
          dangerouslySetInnerHTML={{ __html: products.solutionTitle }}
        />
      </center>

      <div className="container" id="expolare">
        {cardoverlay.map((product, index) => (
          <div
            className={`card-over1 ${!isMobile ? "block-viewsd" : ""} ${
              language === "ar" ? "rtl" : "ltr"
            }`}
            key={index}
          >
            <div className="row justify-content-center align-items-center flex-md-row flex-column">
              <div className="col-12 col-md-4">
                <Link className="under-line link-wrap" to={product.link}>
                 
                  <LazyLoadImage
  src={`${process.env.PUBLIC_URL}${product.image}`}
  alt={product.title}
    className="card-over-img block-view"
/>

                </Link>
              </div>

              <div className="col-12 col-md-8">
                <div className="card-over-con">
                  <Link className="under-line link-wrap" to={product.link}>
                    <h2 className="">{product.title}</h2>
                  </Link>
                  <br />
                  <p className="block-view">{product.desc}</p>
                  <Link className="under-line" to={product.link}>
                    <button className="explore-btn  pro-btn-wrap mt-2">
                      {product.btn} <FaArrowRight />
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>

      {/* GIF Section */}
      <section className='gif-section'>
        <center>
          <h2 className="sec-title text-white">{products.giftitle}</h2>
        </center>
        <LazyLoadImage src={gif} alt="gif" className='gif-imgs' />
      </section>

      {/* CTA Section */}
      <section className='cta'>
        <div className="container">
          <center>
            <div className="cen-sec-con">
              <h2
                className='sec-title text-center block-view'
                dangerouslySetInnerHTML={{ __html: products.proctatitle }}
              ></h2>
              <p
                className="sec-p block-view"
                dangerouslySetInnerHTML={{ __html: products.proctadesc }}
              ></p>

              <Link className="under-line" to="/products">
                <button
                  className={`explore-btn cta-btn my-4 py-2 gap-3 block-view ${
                    language === 'ar' ? 'ar-padding' : 'en-padding'
                  }`}
                >
                  {products.proctabtn}
                  <LazyLoadImage src={arrow} alt="arrow" className="rt-btn" />
                </button>
              </Link>
            </div>
          </center>
        </div>
      </section>
    </>
  );
};

export default Product;
